/* 문화포럼 일정 등록 페이지 */import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import {constance} from '../../common/constance/constance';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {styles} from '../../common/style';
import {Button, MenuItem, MenuList, Paper} from '@mui/material';
import {common} from '../../common/common';
import ImageUploading from 'react-images-uploading';
import {useNavigate} from 'react-router-dom';
import {User} from '../../interface/user.interface';
import {Club} from "../../interface/club.interface";
import WorkplaceComponent from "./WorkplaceComponent";

interface State {
    clubList: Club[];
}

function ClubRegister() {
    const [clubList, setClubList] = useState<Club[]>([]);
    const [images, setImages] = useState([]);

    const clubNameRef: any = useRef();
    const clubKindRef: any = useRef();
    const clubWorkplaceRef: any =useRef();

    useEffect(() => {
        getClubList();
    }, []);

    function getClubList() {
        /* 사용자 리스트 가지고 오기 */
        axios.get(constance.api.getClubList).then((value) => {
            console.log(value.data.clubList);
            setClubList(value.data.clubList);
        }).catch(reason => {
        });
    }

    function handleSave() {
        let clubName: string = clubNameRef.current.value;
        let clubKind: string = clubKindRef.current.value;
        let clubWorkplace: string = clubWorkplaceRef.current.value;


        axios.post(constance.api.saveClub, {
            params: {
                name: clubName,
                kind: clubKind,
                workplace: clubWorkplace,
            },
        }).then(value => {
            if (value.data.result) {
                common.alert('동호회 생성 완료', '', 'info');
            } else {
                common.alert('동호회 생성 실패', '이미 존재하는 동호회 입니다.', 'info');
            }
            clubNameRef.current.value = '';
            clubKindRef.current.value = '';
            getClubList();
        })
    }

    function handleDelete(name: string, kind: string, workplace: string) {
        let callback = (params: { name: string, kind: string, workplace: string }) => {
            return axios.post(constance.api.deleteClub, {
                params: {
                    name: params.name,
                    kind: params.kind,
                    workplace: params.workplace,
                },
            }).then(value => {
                if (value.data.result) {
                    common.alert('동호회 삭제 완료', '', 'info');
                } else {
                    common.alert('동호회 삭제 실패', '', 'info');
                }
                clubNameRef.current.value = '';
                clubKindRef.current.value = '';
                getClubList();
            })
        }
        common.confirm(
            `${name} 동호회를 삭제하시겠습니까?`,
            `동호회를 삭제하면 동호회 게시판에서 해당 동호회의 게시글은 조회되지 않습니다. 
            동호회명을 변경해야 할 경우 IT팀 관리자에게 요청하여 주세요.`,
            'warning',
            callback,
            {name: name, kind: kind, workplace: workplace}
        );
    }

    return (
        <>
            <Stack sx={{width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Box id="box"
                     sx={{
                         display: 'flex',
                         pt: 3,
                         maxWidth: config.maxWidth,
                         width: 1,
                         justifyContent: 'center',
                         alignItems: 'flex-start'
                     }}>
                    <Stack sx={{width: 0.5, height: 1, mr: 3}}>
                        <Paper sx={{width: 1, p: 2}}>
                            <Stack>
                                <Box sx={{width: 1, display: 'flex', mb: 1, borderBottom: styles.border, pb: 1}}>
                                    <Typography align={"center"} sx={{width: 0.2}}>{'사업장'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.3}}>{'동호회명'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.2}}>{'종류'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.2}}>{'생성일'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.1}}>{''}</Typography>
                                </Box>
                                {
                                    clubList.map((value, index) => {
                                        return (
                                            <Box key={index}
                                                 sx={{width: 1, display: 'flex', alignItems: 'center', pt: 0.5, pb: 0.5, borderBottom: styles.border}}>
                                                <Typography align={"center"} sx={{width: 0.2, pl: 0.5, pr: 0.5}}>{constance.workplaceNameMap[value.workplace]}</Typography>
                                                <Typography align={"center"} sx={{width: 0.3, pl: 0.5, pr: 0.5}}>{value.name}</Typography>
                                                <Typography align={"center"} sx={{width: 0.2, pl: 0.5, pr: 0.5}}>{value.kind}</Typography>
                                                <Typography align={"center"} sx={{width: 0.2, pl: 0.5, pr: 0.5}}>{common.getTimeFormatYMD(value.createdAt)}</Typography>
                                                <Button sx={{width: 0.1}}
                                                        size={"small"}
                                                        color={"error"}
                                                        onClick={() => handleDelete(value.name, value.kind, value.workplace)}
                                                        variant={"contained"}>
                                                    <Typography>삭제</Typography>
                                                </Button>
                                            </Box>
                                        )
                                    })
                                }
                            </Stack>
                        </Paper>
                    </Stack>
                    <Stack sx={{
                        width: 0.5,
                        maxWidth: config.maxWidth,
                        alignItems: 'center',
                    }}>
                        {/* 동호회명 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderBottom: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'사업장'}</Typography>
                            </Box>
                            <Stack
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <WorkplaceComponent workplaceRef={clubWorkplaceRef} useAllWorkplace={'N'}/>
                            </Stack>
                        </Box>

                        {/* 동호회명 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'동호회명'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={clubNameRef}
                                           defaultValue={''}
                                           type={'text'}
                                           label="" variant="outlined"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                />
                            </Box>
                        </Box>

                        {/* 종류 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderTop: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'종류'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={clubKindRef}
                                           defaultValue={''}
                                           type={'text'}
                                           label="" variant="outlined"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                />
                            </Box>
                        </Box>

                        <Box sx={{mt: 2}}>
                            <Button onClick={handleSave}
                                    variant={'contained'}>
                                <Typography> {'등록'}</Typography>
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
};

export default ClubRegister;